/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var headerSection = document.getElementById('shopify-section-header');

  if (!headerSection) {
    return;
  }

  var hiddenClass = 'shopify-section--header-hidden';
  var mobileQuery = window.matchMedia('screen and (max-width: 640px)');
  var lastScrollY = window.pageYOffset || 0;
  var isHidden = false;
  var scrollDelta = 1;
  var transitionLockMs = 260;
  var isTransitioning = false;
  var transitionTimer = null;
  var ticking = false;

  function isMobile() {
    return mobileQuery.matches;
  }

  function finishTransition() {
    if (!isTransitioning) {
      return;
    }

    isTransitioning = false;
    lastScrollY = window.pageYOffset || 0;

    if (transitionTimer) {
      window.clearTimeout(transitionTimer);
      transitionTimer = null;
    }
  }

  function onHeaderTransitionEnd(event) {
    if (event.propertyName !== 'transform') {
      return;
    }

    finishTransition();
  }

  function setHidden(hidden) {
    if (hidden === isHidden) {
      return;
    }

    isHidden = hidden;
    headerSection.classList.toggle(hiddenClass, hidden);
    isTransitioning = true;

    if (transitionTimer) {
      window.clearTimeout(transitionTimer);
    }

    transitionTimer = window.setTimeout(finishTransition, transitionLockMs);
  }

  function onScroll() {
    if (isTransitioning) {
      return;
    }

    if (!isMobile()) {
      if (isHidden) {
        setHidden(false);
        return;
      }

      lastScrollY = window.pageYOffset || 0;
      return;
    }

    var currentScrollY = window.pageYOffset || 0;
    var delta = currentScrollY - lastScrollY;

    if (Math.abs(delta) < scrollDelta) {
      return;
    }

    if (currentScrollY <= headerSection.offsetHeight) {
      if (isHidden) {
        setHidden(false);
        return;
      }

      lastScrollY = currentScrollY;
      return;
    }

    if (delta > 0) {
      if (!isHidden) {
        setHidden(true);
        return;
      }
    } else if (isHidden) {
      setHidden(false);
      return;
    }

    lastScrollY = currentScrollY;
  }

  function onScrollThrottled() {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(function () {
      onScroll();
      ticking = false;
    });
  }

  function onResize() {
    if (!isMobile()) {
      setHidden(false);
    }

    lastScrollY = window.pageYOffset || 0;
  }

  window.addEventListener('scroll', onScrollThrottled, { passive: true });
  window.addEventListener('resize', onResize);
  headerSection.addEventListener('transitionend', onHeaderTransitionEnd);

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', onResize);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(onResize);
  }

  onResize();
})();
